import {
  EXPRESS_SHIPPING,
  SHIPPING,
  PICKUP,
  SERVICE_PRESCRIPTION_ONLY,
  SERVICE_PRESCRIPTION_AND_MEDICATION,
} from "../ChooseTreatmentVariants/FreeDosageChooseTreatmentV2/constants";

export type ReorderShippingFields = {
  shippingMethod: string;
  selectedService?: string;
  expressShippingCompany?: string | null;
  expressShippingTier?: string | null;
};

/**
 * Translate the reorder's resolved service option (+ original express provider/tier) into the
 * exact body fields the choose-treatment controller reads (`getServiceOption`). This is what
 * makes the reorder cart load as genuine express instead of collapsing to regular.
 */
export const buildReorderShippingFields = (params: {
  selectedServiceOption: string;
  expressShippingCompany?: string | null;
  expressShippingTier?: string | null;
}): ReorderShippingFields => {
  switch (params.selectedServiceOption) {
    case "express":
      return {
        shippingMethod: EXPRESS_SHIPPING,
        expressShippingCompany: params.expressShippingCompany ?? null,
        expressShippingTier: params.expressShippingTier ?? null,
      };
    case "self_pickup":
      return { shippingMethod: PICKUP, selectedService: SERVICE_PRESCRIPTION_AND_MEDICATION };
    case "only_prescription":
      return { shippingMethod: PICKUP, selectedService: SERVICE_PRESCRIPTION_ONLY };
    case "regular":
    default:
      return { shippingMethod: SHIPPING };
  }
};
